import { JurisdictionCodesType } from 'src/components/Common/Jurisdiction/types';
import { SelectStateInterface } from '../../../../types';

const carolinasImages: { [key: string]: string } = {
  NC01: '/_/media/images/svg/jurisdiction-maps/nc-dec.svg',
  NC02: '/_/media/images/svg/jurisdiction-maps/nc-dep.svg',
  SC01: '/_/media/images/svg/jurisdiction-maps/sc-dec.svg',
  SC02: '/_/media/images/svg/jurisdiction-maps/sc-dep.svg',
};

const carolinasLabels: { [key: string]: string } = {
  '01': 'Duke Energy Carolinas',
  '02': 'Duke Energy Progress',
};

const validJurisdictions: { [key: string]: JurisdictionCodesType } = {
  NC01: 'NC01',
  NC02: 'NC02',
  SC01: 'SC01',
  SC02: 'SC02',
};

const selectState = ({
  stateCode,
  stateOption,
  setRegionSelectModalIsOpen,
  setJurisdiction,
}: SelectStateInterface): void => {
  const jurisdiction = validJurisdictions[stateCode + stateOption];

  setJurisdiction(jurisdiction);
  setRegionSelectModalIsOpen(false);
};

const RegionSelectButton = ({
  stateCode,
  stateOption,
  setRegionSelectModalIsOpen,
  setJurisdiction,
}: SelectStateInterface) => {
  const stateImageCode = stateCode + stateOption;

  return (
    <button
      className="m-12 grow"
      onClick={() =>
        selectState({
          stateCode,
          stateOption,
          setRegionSelectModalIsOpen,
          setJurisdiction,
        })
      }
    >
      <img src={carolinasImages[stateImageCode]} alt=""></img>
      <p className="text-center text-lg text-teal-darker">{carolinasLabels[stateOption]}</p>
    </button>
  );
};

export default RegionSelectButton;
